import { FEATURE_FLAGS } from '@vizit/constants';
import { useFeatureFlag } from './use-feature-flag';

function useShowTagging(): boolean {
  return useFeatureFlag(FEATURE_FLAGS.TAGGING_FE, false);
}

export { useShowTagging };
